import { FunctionComponent } from 'react';
import styles from './Summary.module.css';
import IllustrationHero from '../../assets/images/illustration-hero.svg';
import { ReactComponent as IconImage } from '../../assets/images/icon-music.svg';

interface SummaryProps {
}

const Summary: FunctionComponent<SummaryProps> = (props: SummaryProps) => {
  return (
    <div className={styles.summary}>
      <div className={styles.hero}>
        <img src={IllustrationHero} alt='Hero'/>
      </div>
      <div className={styles.content}>
        <h1>Order Summary</h1>
        <p>You can now listen to millions of songs, audiobooks, and podcasts on any device anywhere you like!</p>
        <div className={styles.card}>
          <div><IconImage/></div>
          <div className={styles.description}>
            <div className={styles.plan}>Annual Plan</div>
            <div className={styles.price}>$59.99/year</div>
          </div>
          <div className={styles.change}>Change</div>
        </div>
        <div className={styles.checkout}>Proceed to Payment</div>
        <div className={styles.cancel}>Cancel Order</div>
      </div>
    </div>
  );
};

export default Summary;